import React, { useState } from 'react';
import './App.css';
import Step1 from './components/Step1';
import Step2 from './components/Step2';
import Step3 from './components/Step3';
import Step4 from './components/Step4';
import Step5 from './components/Step5';
import FinalStep from './components/FinalStep';

function App() {
  const [currentStep, setCurrentStep] = useState(1);

  const nextStep = () => {
    setCurrentStep(currentStep + 1);
  };

  return (
    <div className="App">
      {currentStep === 1 && <Step1 onNext={nextStep} />}
      {currentStep === 2 && <Step2 onNext={nextStep} />}
      {currentStep === 3 && <Step3 onNext={nextStep} />}
      {currentStep === 4 && <Step4 onNext={nextStep} />}
      {currentStep === 5 && <Step5 onNext={nextStep} />}
      {currentStep === 6 && <FinalStep />}
    </div>
  );
}

export default App;
